import { categories, siteName } from '@/mocks/gossip';

const siteNav = [
  { href: '#pan', label: '分类盘点' },
  { href: '#moments', label: '高能瞬间' },
  { href: '#hot', label: '今日热瓜榜' },
  { href: '#talk', label: '吃瓜FAQ' },
  { href: '#about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* 品牌 */}
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-400 font-display text-xl font-black text-foreground-950">
                瓜
              </span>
              <div>
                <p className="font-display text-xl font-black text-background-50">{siteName}</p>
                <p className="mt-0.5 text-[9px] font-medium tracking-[0.3em] text-accent-300">
                  GOSSIP DAILY
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-100/80">
              一份专注红毯与活动造型的娱乐时尚点评小报。把红毯翻车、撞衫对比、妆容失败、
              时尚灾难一次看够，用轻松又认真的态度，陪你一起吃瓜学穿搭。
            </p>
            <div className="mt-5 flex items-center gap-2 text-background-100/60">
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-background-50/20">
                <i className="ri-wechat-line text-base"></i>
              </span>
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-background-50/20">
                <i className="ri-global-line text-base"></i>
              </span>
              <span className="inline-flex h-8 w-8 items-center justify-center rounded-full border border-background-50/20">
                <i className="ri-mail-line text-base"></i>
              </span>
            </div>
          </div>

          {/* 栏目 */}
          <div>
            <h4 className="text-sm font-bold tracking-wide text-accent-300">常设栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <a
                    href="#pan"
                    className="inline-flex items-center gap-1.5 text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    <i className={`${c.icon} text-accent-300`}></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 站点 */}
          <div>
            <h4 className="text-sm font-bold tracking-wide text-accent-300">快速跳转</h4>
            <ul className="mt-4 space-y-2.5">
              {siteNav.map((l) => (
                <li key={l.href + l.label}>
                  <a
                    href={l.href}
                    className="text-sm text-background-100/80 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-100/60">
            © 2026 {siteName}. All rights reserved. · 观点仅代表编辑部，不构成对任何个人的负面评价。
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium text-background-100/70 transition-colors hover:text-background-50"
          >
            回到顶部
            <i className="ri-arrow-up-s-line text-base"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}